import { HiPaperAirplane } from "react-icons/hi2";

export const SendIcon = ({ width, height, color, ...props }) => (
  <HiPaperAirplane
    size={width || height || 16}
    color={color || "currentColor"}
    {...props}
  />
);
